module.exports = __webpack_public_path__ + "img/beobasta.03f77909.png";